import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export const sliderJobs = (function () {
  const init = function () {
    const swiper = new Swiper(".slider-jobs", {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: "true",
        type: "bullets",
        bulletElement: "button",
      },
      spaceBetween: 60,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        1366: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  };

  return {
    init,
  };
})();
